"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "bg-beige-400 flex justify-center px-5" };
const _hoisted_2 = { class: "w-full max-w-screen-xl" };
const _hoisted_3 = { class: "grid grid-flow-col my-1 items-center" };
const _hoisted_4 = { class: "hidden sm:block" };
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "block sm:hidden flex justify-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "w-[10px] h-[10px] rounded-full bg-mutedpurple-800" })
], -1);
const _hoisted_6 = { class: "bg-beige-500 h-[10px] rounded-t-full overflow-hidden relative" };
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProficiencyTestNav',
    props: {
        sections: Array,
        currentSection: Object,
    },
    setup(__props) {
        const props = __props;
        const progressStyle = (0, vue_3.computed)(() => {
            var _a, _b;
            const sectionCount = (_a = props.sections) === null || _a === void 0 ? void 0 : _a.length;
            if (!props.currentSection) {
                return {
                    width: '100%',
                };
            }
            if (!sectionCount) {
                return;
            }
            const indexOfCurrent = (_b = props.sections) === null || _b === void 0 ? void 0 : _b.indexOf(props.currentSection);
            if (typeof indexOfCurrent !== 'number') {
                return;
            }
            const percentDone = (Math.min(indexOfCurrent + 1, sectionCount) / sectionCount) * 100;
            return {
                width: `${percentDone}%`,
            };
        });
        function isCurrent(section) {
            if (!props.currentSection) {
                return false;
            }
            return section.name === props.currentSection.name;
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("nav", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.sections, (section) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: section.id,
                                class: (0, vue_2.normalizeClass)(["text-center text-xxs uppercase font-semibold py-3 tracking-widest", isCurrent(section) ? 'bg-beige-200 rounded-full' : ''])
                            }, [
                                (0, vue_2.createElementVNode)("span", _hoisted_4, (0, vue_2.toDisplayString)(section.name), 1),
                                _hoisted_5
                            ], 2));
                        }), 128))
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                        (0, vue_2.createElementVNode)("div", {
                            style: (0, vue_2.normalizeStyle)((0, vue_2.unref)(progressStyle)),
                            class: "absolute left-0 top-0 h-full bg-teal-400"
                        }, null, 4)
                    ])
                ])
            ]));
        };
    }
});
